// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-button[data-v-805aead8]{min-height:25px!important;height:25px!important;width:200px!important}.category-button[data-v-805aead8],.category-button-mobile[data-v-805aead8]{border-radius:5px!important;margin-right:20px;float:left}.category-button-mobile[data-v-805aead8]{min-height:20px!important;height:20px!important;width:150px!important;margin-top:0!important}.social-icon[data-v-805aead8]{float:left;padding:0}", ""]);
// Exports
module.exports = exports;
